import { useState } from "react";
import { noRecordsAlert } from "../../../../../_helpers/Helpers";
import { StudentsUIProvider } from "./StudentsUIContext";
import { StudentRegistrationCancellation } from "./student-registration-cancellation/StudentRegistrationCancellation";
import { StudentsCard } from "./StudentsCard";

export function StudentsPage({ history }) {
  const [ids, setIds] = useState();
  const [term, setTerm] = useState();
  const [showRegistrationCancellation, setShowRegistrationCancellation] = useState();
  const closeRegistrationCancellation = () => setShowRegistrationCancellation(false);

  const studentsUIEvents = {
    openNewStudentPage: () => {
      history.push("/ogrenciler/ekle");
    },
    openEditStudentPage: (page, term, id) => {
      history.push(`/ogrenciler/${page}/${term}/${id}`);
    },
    openRegistrationCancellationModal: (term, ids) => {
      if (typeof ids === 'string') ids = ids.split(",");
        
      if (ids.length < 1) {
        noRecordsAlert();
        return;
      }
      setIds(ids);
      setTerm(term);
      setShowRegistrationCancellation(true);
    }
  };
  
  return (
    <StudentsUIProvider studentsUIEvents={studentsUIEvents}>
      <StudentRegistrationCancellation
        ids={ids}
        term={term}
        showRegistrationCancellation={showRegistrationCancellation}
        closeRegistrationCancellation={closeRegistrationCancellation}
      />
      <StudentsCard />
    </StudentsUIProvider>
 );
}